(function () {
    'use strict';

    angular.module("imApp").factory("rfidConnectService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1768,
                    parameters: parms || {}
                });
            },
            listRfidConnects: function (parms) {
                return $ihttp.post({
                    method: 1769,
                    parameters: parms || {}
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 1770,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
